import { Component } from '@angular/core';
import { Observable, take } from 'rxjs';
import { UserService } from 'src/app/user.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'sdc-home',
  templateUrl: './home.component.html',
  styles: [
  ]
})
export class HomeComponent {
  public userName: string;
  public role: string;
  user: Observable<any>;

  constructor(
    private userService: UserService,
    private authService: AuthService
  ) {
    
  }

  ngOnInit(){
    this.userName = JSON.parse(localStorage.getItem('currentUser')).userName;
    this.role = JSON.parse(localStorage.getItem('currentUser')).role;
  }

  dbBackup(){
    /*this.authService.apiAuthBackupDbPost().pipe(take(1)).subscribe(res => {
      if (res == "Failure")//.userName != null)
      {
        alert('Database Backup Failure!');
      }
      else
      {
        alert("Database Backup Successful!");
      }
    });*/
  }
}
